import apiClient from '../../../common/services/apiClient';

export const apiCallIds = {
  FETCH_DEVICES: 'MOBILE/FETCH_DEVICES',
  DEACTIVATE_DEVICE: 'MOBILE/DEACTIVATE_DEVICE',
  SEND_PIN_SMS: 'MOBILE/SEND_PIN_SMS',
  CHANGE_PIN: 'MOBILE/CHANGE_PIN',
};

export default {
  fetchDevices: () => {
    return apiClient.get('/mobile/devices', {
      apiCallId: apiCallIds.FETCH_DEVICES,
    });
  },

  deactivateDevice: (deviceId) => {
    return apiClient.delete(`/mobile/devices/${deviceId}`, {
      apiCallId: apiCallIds.DEACTIVATE_DEVICE,
    });
  },

  sendPinSms: (deviceId) => {
    return apiClient.post('/mobile/pin/send-sms', { device_id: deviceId }, {
      apiCallId: apiCallIds.SEND_PIN_SMS,
    });
  },

  changePin: ({ device_id, current_pin, new_pin, sms_code }) => {
    return apiClient.post('/mobile/pin/change', { device_id, current_pin, new_pin, sms_code }, {
      apiCallId: apiCallIds.CHANGE_PIN,
    });
  },
};



// WEBPACK FOOTER //
// ./src/features/user-settings/api/index.js